// PortalShell — sidebar + main-content shell for authenticated routes.
import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';

export function PortalShell(): React.ReactNode {
  return (
    <div className="flex min-h-screen bg-cream">
      <Sidebar />
      <main
        id="main-content"
        tabIndex={-1}
        className="flex flex-1 flex-col px-6 py-8 md:px-12 md:py-12"
      >
        <Outlet />
      </main>
    </div>
  );
}
